<template>
  <div class="login-container bg-background" id="login">
    <div class="login-form mt-10">
      <div class="flex justify-center"></div>
      <div
        class="absolute top-12 left-0 flex w-full select-none items-center justify-between px-[24px]"
      >
        <div
          v-if="currentStep === enumLoginSteps.CreatePass"
          class="flex h-9 items-center justify-center rounded-lg bg-greyLight px-4 text-grey"
          @click="changePhone"
        >
          <i class="fas fa-chevron-left" />
          <div class="ml-3 text-sm">Назад</div>
        </div>
        <div
          v-if="currentStep === enumLoginSteps.RepeatPass"
          class="flex h-9 items-center justify-center rounded-lg bg-greyLight px-4 text-grey"
          @click="currentStep = enumLoginSteps.CreatePass"
        >
          <i class="fas fa-chevron-left" />
          <div class="ml-3 text-sm">Назад</div>
        </div>
        <div
          v-if="currentStep === enumLoginSteps.ActivationMethod"
          class="flex h-9 items-center justify-center rounded-lg bg-greyLight px-4 text-grey"
          @click="currentStep = enumLoginSteps.RepeatPass"
        >
          <i class="fas fa-chevron-left" />
          <div class="ml-3 text-sm">Назад</div>
        </div>
        <div
          v-if="currentStep === enumLoginSteps.TelegramRedirect"
          class="flex h-9 items-center justify-center rounded-lg bg-greyLight px-4 text-grey"
          @click="currentStep = enumLoginSteps.EnterPhone"
        >
          <i class="fas fa-chevron-left" />
          <div class="ml-3 text-sm">Назад</div>
        </div>

        <div
          v-if="currentStep === enumLoginSteps.CheckOTP"
          class="flex h-9 items-center justify-center rounded-lg bg-greyLight px-4 text-grey"
          @click="resetData"
        >
          <i class="fas fa-chevron-left" />
          <div class="ml-3 text-sm">В начало</div>
        </div>
      </div>
      <div v-auto-animate>
        <template v-if="currentStep === enumLoginSteps.EnterPhone">
          <LoginStep
            :title="['Вход в кабинет выплат для', 'водителей и курьеров']"
            subtitle="Введите ваш номер телефона в поле ниже"
          >
            <template v-slot:action>
              <div class="form-input">
                <InputComponent
                  v-model="phone"
                  :model="phone"
                  @keyup="validateFieldInput('phone')"
                  maxlength="15"
                  rounded="md"
                  id="loginPhone"
                  prefix="+7"
                  height="h-14"
                  :border="false"
                  @paste="onPaste"
                  :disabled="hasRequest"
                  background="bg-greyLight"
                  :mask="'(###) ### ## ##'"
                  placeholder="(***) *** ** **"
                  type="tel"
                />
                <div class="mt-5">
                  <CheckboxComponent
                    :disabled="hasRequest"
                    :model="termsConditionFirst"
                    @update="(value) => (termsConditionFirst = value)"
                  >
                    <template v-slot:label>
                      Я ознакомился и согласен с
                      <a
                        @click.stop="openLink(`${privacyLink}`)"
                        href="#"
                        class="text-blue underline"
                      >
                        политикой конфиденциальности
                      </a>
                    </template>
                  </CheckboxComponent>
                  <CheckboxComponent
                    :disabled="hasRequest"
                    :model="termsConditionSecond"
                    @update="(value) => (termsConditionSecond = value)"
                    class="mt-4"
                  >
                    <template v-slot:label>
                      Я ознакомился и согласен с
                      <a
                        @click.stop="openLink(`${agreementLink}`)"
                        href="#"
                        class="text-blue underline"
                      >
                        пользовательским соглашением
                      </a>
                    </template>
                  </CheckboxComponent>
                </div>
                <ButtonComponent
                  type="submit"
                  title="Продолжить"
                  font="normal"
                  rounded="md"
                  :disabled="
                    phone.length !== 15 ||
                    !termsConditionSecond ||
                    !termsConditionFirst
                  "
                  class="mt-5 h-14 font-normal"
                  :loading="hasRequest"
                  :color="
                    phone.length === 15 &&
                    termsConditionSecond &&
                    termsConditionFirst
                      ? 'primary'
                      : 'greyLight'
                  "
                  @clickAction="sendPhoneToValidate()"
                />
              </div>
            </template>
          </LoginStep>
        </template>
        <template v-if="currentStep === enumLoginSteps.CreatePass">
          <img
            src="../../assets/img/login-staps/pwd.png"
            class="w-[4rem] mx-auto"
          />
          <login-step
            :subtitle="
              isNeedRegistration
                ? 'Комбинацию из 5 цифр \n — этот пароль вы будете использовать для входа в приложение'
                : 'Который вы установили при первом входе'
            "
            :title="
              isNeedRegistration
                ? ['Придумайте новый пароль']
                : ['Введите пароль']
            "
            :attention="
              passwordError && passwordError.length ? passwordError : null
            "
          >
            <template v-slot:action>
              <div class="form-password">
                <div class="flex">
                  <template v-for="i in 5" :key="i">
                    <input
                      :class="{ active: password[i - 1] }"
                      @keyup.delete="keyDownEvent('password')"
                      @input="
                        inputPasswordEvent('password', $event.target.value)
                      "
                      ref="input"
                      type="password"
                      :value="password[i - 1]"
                      @focus="onFocusPassword('password')"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      autocomplete="off"
                      maxlength="1"
                      class="input-box focus:border focus:border-yellow-200"
                    />
                  </template>
                </div>
                <button-component
                  :disabled="!isCreateContinueEnabled"
                  class="form-button mb-3"
                  :loading="hasRequest"
                  id="continueButton"
                  font="normal"
                  type="submit"
                  rounded="md"
                  :color="isCreateContinueEnabled ? 'primary' : 'greyLight'"
                  @clickAction="validateIsNeedRegistration"
                  title="Продолжить"
                />
              </div>
              <div
                v-if="isNeedRegistration && passwordWeakHint"
                class="mt-2 text-center text-sm text-red"
              >
                {{ passwordWeakHint }}
              </div>
              <div v-show="!helpLoginDialog">
                <div
                  id="yandex-auth-container-login"
                  class="yandex-button mt-2"
                ></div>
              </div>
            </template>
          </login-step>
        </template>
        <template v-if="currentStep === enumLoginSteps.TelegramRedirect">
          <login-step
            :title="`Вы можете установить пароль к аккаунту ${phone}`"
            subtitle="Удобным для вас способом:
            "
          >
            <template v-slot:action>
              <div class="flex flex-col space-y-2">
                <div class="mx-4 flex justify-center">
                  <button-component
                    class="form-button"
                    font="normal"
                    rounded="md"
                    color="primary"
                    @clickAction="currentStep = enumLoginSteps.CreatePass"
                    ><template v-slot:title v-if="yandexAppEnabled">
                      <div class="">
                        Установить пароль через
                        <span
                          class="inline-flex items-center gap-1 whitespace-nowrap"
                        >
                          <strong>ЗВОНОК</strong>

                          /
                          <img
                            src="@/assets/img/yandex-short.png"
                            class="w-5 h-5"
                          />
                          <strong>Яндекс ID</strong>
                        </span>
                      </div>
                    </template>
                    <template v-slot:title v-else
                      >Установить пароль через <strong>ЗВОНОК</strong></template
                    >
                  </button-component>
                </div>
                <div
                  class="flex items-center justify-center text-gray-600 text-sm mb-4"
                >
                  ИЛИ
                </div>
                <div
                  class="flex flex-col justify-center text-center border border-grey-400 p-4 rounded-lg space-y-2"
                >
                  <div
                    @click="openTelegram()"
                    class="flex items-center justify-center select-none cursor-pointer overflow-hidden px-6 text-center transition-all duration-300 rounded-md grey h-14 font-normal bg-primary w-full text-grey opacity-100"
                  >
                    Перейти в
                    <img
                      src="../../assets/img/general/tg.svg"
                      alt="telegram"
                      class="ml-2 w-6 h-6"
                    /><strong class="ml-1">Telegram</strong>
                  </div>
                  <!-- <div
                    @click="openTelegram()"
                    class="flex items-center justify-center select-none cursor-pointer overflow-hidden px-6 text-center transition-all duration-300 rounded-md grey h-14 font-normal bg-primary w-full text-grey opacity-100"
                  >
                    <img
                      src="../../assets/img/general/max.svg"
                      alt="telegram"
                      class="mr-2 w-6 h-6"
                    />
                    Перейти в MAX
                  </div> -->
                  <div class="text-gray-600 text-sm">
                    Это обезопасит вас от мошенников и вы сможете получать коды
                    доступа для входа
                  </div>
                </div>
              </div>
            </template>
          </login-step>
        </template>
        <template v-if="currentStep === enumLoginSteps.RepeatPass">
          <img
            src="../../assets/img/login-staps/pwd-repeat.png"
            class="w-[4rem] mx-auto"
          />
          <login-step
            :title="['Повторите пароль']"
            :attention="
              !passwordRepeat.length && passwordRepeatError
                ? passwordRepeatError
                : null
            "
          >
            <template v-slot:action>
              <div class="form-password">
                <div class="flex">
                  <template v-for="i in 5" :key="i">
                    <input
                      :class="{ active: passwordRepeat[i - 1] }"
                      ref="input"
                      @keyup.delete="keyDownEvent('passwordRepeat')"
                      @focus="onFocusPassword('passwordRepeat')"
                      :disabled="hasRequest"
                      @input="
                        inputPasswordEvent(
                          'passwordRepeat',
                          $event.target.value,
                        )
                      "
                      :value="passwordRepeat[i - 1]"
                      inputmode="numeric"
                      pattern="[0-9]*"
                      type="password"
                      autocomplete="off"
                      maxlength="1"
                      class="input-box focus:border focus:border-yellow-200"
                    />
                  </template>
                </div>

                <button-component
                  :disabled="
                    passwordRepeat.length < 5 || passwordRepeat !== password
                  "
                  class="form-button"
                  font="normal"
                  type="submit"
                  :loading="hasRequest"
                  rounded="md"
                  :color="passwordRepeat.length === 5 ? 'primary' : 'greyLight'"
                  title="Продолжить"
                  @clickAction="activateUser"
                />
              </div>
            </template>
          </login-step>
        </template>
        <template v-if="currentStep === enumLoginSteps.CheckOTP">
          <img
            src="../../assets/img/login-staps/pwd-send.png"
            class="w-[4rem] mx-auto"
          />
          <login-step
            :attention="otpError && otpError.length ? otpError : null"
            :title="
              loginType === 'phone'
                ? ['На ваш телефон поступит звонок', 'Возьмите трубку']
                : ['Вам в Telegram отправлен код для входа', 'Впишите его ниже']
            "
          >
            <template v-slot:title v-if="loginType !== 'phone'">
              <div>На ваш Telegram {{ phone }} отправлен код для входа</div>
              <div>
                Перейдите по
                <span
                  class="text-blue cursor-pointer"
                  @click="onTelegramCodeLinkClick"
                  >ссылке</span
                >
              </div>
              <div>Впишите его ниже</div>
            </template>
            <template v-slot:action>
              <div class="form-input">
                <input-component
                  v-model="otp"
                  :model="otp"
                  height="h-14"
                  rounded="md"
                  :border="false"
                  background="bg-greyLight"
                  :loading="hasRequest"
                  @input="validateOTP"
                  @keyup="validateFieldInput('otp')"
                  maxlength="5"
                  :placeholder="
                    loginType == 'phone' ? 'Код из звонка' : 'Код из Telegram'
                  "
                  outlined
                  type="tel"
                />
              </div>
              <template v-if="callsTries < 2 && loginType == 'phone'">
                <div
                  class="mt-2 flex justify-center text-grey"
                  v-if="nextCallTime > 0"
                >
                  Позвонить еще раз ({{ nextCallTime }}c)
                </div>
                <div
                  v-else
                  class="mt-2 flex cursor-pointer justify-center text-blue"
                  @click="sendNewCall"
                >
                  Позвонить еще раз
                </div>
                <!-- <div class="flex justify-center text-center mt-5">
                  Если звонок не приходит, вернитесь в начало и установите
                  пароль через телеграм
                </div> -->
                <TelegramBanner class="mt-5" />
              </template>
            </template>
          </login-step>
        </template>
        <template v-if="currentStep === enumLoginSteps.ActivationMethod">
          <LoginStep
            title="Подтвердите активацию"
            :subtitle="yandexAppEnabled ? 'Выберите способ подтверждения' : ''"
          >
            <template v-slot:action>
              <div class="flex flex-col space-y-4">
                <div
                  v-if="yandexAppEnabled"
                  class="flex flex-col justify-center text-center border border-grey-400 p-4 rounded-lg space-y-2"
                  v-show="!helpLoginDialog"
                >
                  <div class="text-gray-600 text-sm">
                    Один клик — и вы в системе.
                  </div>
                  <div
                    id="yandex-auth-container-activation"
                    class="yandex-button"
                  ></div>
                </div>
              </div>
              <div class="mx-4 mt-4">
                <ButtonComponent
                  class="form-button mb-3"
                  font="normal"
                  rounded="md"
                  color="primary"
                  @clickAction="sendActivationCall"
                  title="Через ЗВОНОК"
                />
              </div>
            </template>
          </LoginStep>
        </template>
        <template v-if="currentStep === enumLoginSteps.Confirmation">
          <img
            src="../../assets/img/login-staps/call.png"
            class="w-[4rem] mx-auto"
            v-if="activeTab === 'call'"
          />
          <img
            src="../../assets/img/login-staps/support.png"
            class="w-[4rem] mx-auto"
            v-else
          />
          <LoginStep
            :title="
              activeTab === 'call'
                ? `Позвоните с номера ${this.phone}`
                : 'Проблема со ЗВОНКОМ'
            "
            :subtitle="
              activeTab === 'call'
                ? `на номер ниже в течение 5 минут \n Убедитесь что совершаете звонок с номера ${this.phone}, иногда вызов может идти со второй сим карты!`
                : `Код подтверждения аккаунта ${this.phone}`
            "
          >
            <template v-if="activeTab === 'call'" #action>
              <div
                class="text-center font-medium text-xl flex flex-col items-center space-y-4"
              >
                <div
                  v-for="(number, index) in phoneNumberCallConfirmed"
                  :key="index"
                  class="flex space-x-4 items-center ml-6"
                >
                  <a
                    class="cursor-pointer select-none border rounded-full py-2 px-6 text-center text-blue-500 hover:shadow-blue-200 flex items-center justify-center gap-2 mx-auto max-w-[280px] bg-[#0FC22F] text-white"
                    :href="`tel:${number}`"
                  >
                    <i class="fas fa-phone text-sm rotate-90 animate-pulse"></i>
                    <div class="animate-pulse">
                      {{ formatCallConfirmNumber(number) }}
                    </div>
                  </a>
                  <div class="cursor-pointer" @click="copyNumber(number)">
                    <i
                      class="fa fa-copy text-sm text-[1rem] text-[#787878]"
                    ></i>
                  </div>
                </div>
              </div>

              <div class="text-center text-grey-400 my-4">
                Ожидание звонка
                {{ formatTime(remainingTime) }}
              </div>

              <template v-if="!isCallConfirmed && remainingTime <= 240">
                <ButtonComponent
                  :title="
                    isManualCallCheckDisabled ? 'Проверяем...' : 'Я позвонил'
                  "
                  color="primary"
                  rounded="md"
                  class="w-full h-14 mb-6"
                  @clickAction="manuallyCheckStatus"
                  :disabled="isManualCallCheckDisabled"
                />
              </template>
            </template>

            <template v-else #action>
              <div class="text-center mb-4 text-grey">
                Подготовьте скриншот данного экрана и предоставьте его в
                поддержку<br />
                (
                <strong
                  v-if="showMaxSupport"
                  class="cursor-pointer text-blue underline"
                  @click="handleMAXSupportRequest"
                  >MAX </strong
                >/<strong
                  class="cursor-pointer text-blue underline"
                  @click="handleTelegramSupportRequest"
                  >Telegram </strong
                >)
              </div>
              <InputComponent
                v-model="manualCode"
                :model="manualCode"
                maxlength="5"
                placeholder="00000"
                height="h-14"
                rounded="md"
                :border="false"
                background="bg-greyLight"
                type="tel"
                class="mb-4"
                @input="validateManualCode"
              />
              <div class="flex justify-between">
                <ButtonComponent
                  title="Назад"
                  color="greyLight"
                  rounded="md"
                  class="h-14 flex-1 mr-2"
                  @clickAction="backBtn()"
                />
                <ButtonComponent
                  :title="'Подтвердить'"
                  :disabled="manualCode.length !== 5"
                  :color="manualCode.length === 5 ? 'primary' : 'greyLight'"
                  rounded="md"
                  class="h-14 flex-1 ml-2"
                  :loading="isSubmittingCode"
                  @clickAction="submitManualCode"
                />
              </div>
            </template>
          </LoginStep>

          <div class="mt-6 flex justify-center">
            <button
              type="button"
              class="text-red font-medium border border-red rounded-md px-4 py-2"
              @click="showCloseConfirm = true"
            >
              В начало
            </button>
            <div
              v-if="
                currentStep === enumLoginSteps.Confirmation &&
                activeTab === 'call'
              "
              class="flex absolute bottom-0 right-0"
            >
              <button
                type="button"
                class="text-blue font-medium underline"
                @click="switchTab('code')"
              >
                <img
                  class="w-[1.5rem] opacity-30"
                  src="../../assets/img/login-staps/question.png"
                />
              </button>
            </div>
          </div>

          <!-- Модал подтверждения закрытия -->
          <ConfirmModal
            v-if="showCloseConfirm"
            :state="showCloseConfirm"
            description="Вы уверены, что хотите закрыть окно подтверждения? Все данные будут сброшены."
            confirm-button-text="Да, закрыть"
            decline-button-text="Отмена"
            @confirm="handleCloseConfirmation"
            @decline="showCloseConfirm = false"
          />
        </template>
      </div>
      <confirm-modal
        v-if="showMaxSupport"
        :description="
          currentStep === enumLoginSteps.Confirmation
            ? `Перед обращением в поддержку проверьте что звонок совершался с номера ${this.phone}. \n(иногда звонок идет со второй сим карты) \n Остались вопросы? Решим!\n Подготовьте скриншот экрана!`
            : 'У Вас трудность? Решим! Подготовьте скриншот экрана!'
        "
        :state="helpLoginDialog"
        decline-button-text="Не сейчас"
        @confirm="handleMAXSupportRequest"
        @confirmSecondary="handleTelegramSupportRequest"
        @decline="helpLoginDialog = false"
      >
        <template v-slot:confirm-title>
          <div class="flex items-center font-medium">
            <div>В MAX</div>
            <div class="ml-2 text-2xl">
              <img
                src="../../assets/img/general/max-black.svg"
                alt="MAX"
                class="w-4 h-4 items-center text-center align-middle"
              />
            </div>
          </div>
        </template>
        <template v-slot:confirm-secondary-title>
          <div class="flex items-center font-medium">
            <div>В Telegram</div>
            <div class="ml-2 text-2xl">
              <i class="fab fa-telegram-plane" />
            </div>
          </div>
        </template>
      </confirm-modal>
      <confirm-modal
        v-else
        :description="
          currentStep === enumLoginSteps.Confirmation
            ? `Перед обращением в поддержку проверьте что звонок совершался с номера ${this.phone}. \n(иногда звонок идет со второй сим карты) \n Остались вопросы? Решим!\n Подготовьте скриншот экрана!`
            : 'У Вас трудность? Решим! Подготовьте скриншот экрана!'
        "
        :state="helpLoginDialog"
        decline-button-text="Не сейчас"
        @confirm="handleTelegramSupportRequest"
        @decline="helpLoginDialog = false"
      >
        <template v-slot:confirm-title>
          <div class="flex items-center font-medium">
            <div>В Telegram</div>
            <div class="ml-2 text-2xl">
              <i class="fab fa-telegram-plane" />
            </div>
          </div>
        </template>
      </confirm-modal>
    </div>
    <div class="flex justify-center">
      <div
        :class="[
          'absolute maxH:static bottom-12 min-top-[600px] flex flex-col items-center rounded-full px-4 py-1 text-sm font-medium',
          isHelpButtonEnabled
            ? 'bg-primary text-grey cursor-pointer'
            : 'bg-greyLight text-greyDisabled cursor-not-allowed opacity-50',
        ]"
        @click="handleHelpButtonClick"
      >
        <div class="flex items-center">
          <div class="text-2xl">
            <img
              src="../../assets/img/general/error.svg"
              alt="MAX"
              class="w-5 h-5 items-center text-center align-middle"
            />
          </div>
          <div class="ml-2 text-base">Не могу войти</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ApiEnter from "@/api/ApiEnter";
import ButtonComponent from "@/components/Common/ButtonComponent.vue";
import CheckboxComponent from "@/components/Common/CheckboxComponent.vue";
import InputComponent from "@/components/Common/InputComponent.vue";
import LoginStep from "@/components/Enter/LoginStep.vue";
import TelegramBanner from "@/components/MainPage/TelegramBanner.vue";
import ConfirmModal from "@/components/Modals/ConfirmModal.vue";
import StatusModal from "@/components/Modals/StatusModal.vue";
import store from "@/store";
import { ELoginStep } from "@/struct/ELogin/ELoginStep";
import { IAuthSuccessResponse } from "@/struct/ILogin/ILogin";
import { isAuthSuccess } from "@/util/auth";
import UtilStorage from "@/util/Common/UtilStorage";
import UtilError from "@/util/ValidateError/UtilError";
import { getWeakPasswordHint } from "@/util/ValidatePassword/UtilPassword";
import { App } from "@capacitor/app";
import { Browser } from "@capacitor/browser";
import { Clipboard } from "@capacitor/clipboard";
import { Toast } from "@capacitor/toast";
import * as Sentry from "@sentry/vue";
import { Action, Getter, Mutation } from "s-vuex-class";
import { Options, Vue } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { toast } from "vue3-toastify";

interface YandexAuthData {
  access_token?: string;
  [key: string]: any;
}

interface YandexAuthError {
  error: string;
  error_description?: string;
  [key: string]: any;
}

@Options({
  components: {
    TelegramBanner,
    ConfirmModal,
    StatusModal,
    CheckboxComponent,
    ButtonComponent,
    InputComponent,
    LoginStep,
  },
  name: "LoginPage",
})
export default class LoginPage extends Vue {
  @Action("getUserData") private getUserData: (() => void) | undefined;

  @Action("getYandexAppEnabled") private getYandexAppEnabled:
    | (() => void)
    | undefined;

  @Getter("yandexAppEnabled") private yandexAppEnabled!: boolean;

  @Getter("appName") private appName: string | undefined;

  @Getter("yandexClientId") private yandexClientId: string | undefined;

  @Action("fetchUserCards") private fetchUserCards: (() => void) | undefined;

  @Getter("validateUserPlatform") private platformApp: string | undefined;

  @Getter("getCurrentLoginStep") private getCurrentStep: ELoginStep | undefined;
  @Mutation("setCurrentStep") private setCurrentStep:
    | ((value: ELoginStep) => void)
    | undefined;

  @Getter("getLoginPhone") private getLoginPhone: string | undefined;
  @Mutation("setLoginPhone") private setLoginPhone:
    | ((value: string) => void)
    | undefined;

  @Getter("getLoginPassword") private getLoginPassword: string | undefined;
  @Mutation("setLoginPassword") private setLoginPassword:
    | ((value: string) => void)
    | undefined;

  @Getter("getIsNeedRegistration") private getIsNeedRegistration:
    | boolean
    | undefined;
  @Mutation("setIsNeedRegistration") private setIsNeedRegistration:
    | ((value: boolean) => void)
    | undefined;

  @Getter("getConnectionState") private statusConnection: boolean | undefined;

  declare $refs: {
    vue: Vue;
    element: HTMLInputElement;
    input: HTMLInputElement;
    elements: HTMLInputElement[];
  };

  get isValidPhone(): boolean {
    return this.phone.length === 15;
  }

  get isHelpButtonEnabled(): boolean {
    if (this.currentStep === ELoginStep.EnterPhone) {
      return this.phone.length === 15;
    }
    return true;
  }

  get passwordWeakHint(): string | null {
    if (!this.isNeedRegistration) {
      return null;
    }
    if (!this.password) {
      return null;
    }
    return getWeakPasswordHint(this.password);
  }

  get isCreateContinueEnabled(): boolean {
    if (this.password.length !== 5) {
      return false;
    }
    if (!this.isNeedRegistration) {
      return true;
    }
    return this.passwordWeakHint === null;
  }
  private isBrand = process.env.VUE_APP_BRAND_ID;
  private agreementLink = process.env.VUE_APP_LEGAL_LINK;
  private privacyLink = process.env.VUE_APP_POLICY_LINK;

  private get showMaxSupport(): boolean {
    const allowedBrands = [
      "",
      "3e85e76b00b84703844d8347aff3d0b8",
      "82e8c1ebec3b4b86a16c29a550f4854e",
    ];
    return allowedBrands.includes(this.isBrand);
  }
  private inactivityTimer: number | null = null;
  private readonly INACTIVITY_TIMEOUT = 2 * 60 * 1000;

  @Watch("currentStep")
  private onCurrentStepChanged(newStep: ELoginStep, oldStep: ELoginStep) {
    // Очищаем предыдущий таймер
    this.clearInactivityTimer();

    // Запускаем новый таймер, если шаг не равен EnterPhone и Confirmation
    if (
      newStep !== ELoginStep.EnterPhone &&
      newStep !== ELoginStep.Confirmation
    ) {
      this.startInactivityTimer(newStep);
    }

    //  Таймер для Confirmation шага
    if (newStep === ELoginStep.Confirmation) {
      this.startCountdown();
      this.startPolling();
      window.addEventListener("beforeunload", this.blockUnload);
    } else if (oldStep === ELoginStep.Confirmation) {
      this.cleanup();
      window.removeEventListener("beforeunload", this.blockUnload);
    }

    if (
      newStep === ELoginStep.EnterPhone &&
      oldStep !== ELoginStep.EnterPhone
    ) {
      if (this.phone && this.phone.trim() !== "") {
        this.validateFieldInput("phone");
      }
    }
  }

  private startInactivityTimer(step: ELoginStep): void {
    this.inactivityTimer = window.setTimeout(() => {
      // Проверяем, что мы все еще на том же шаге
      if (this.currentStep === step && window.location.hash == "#/") {
        this.handleInactivityTimeout();
      }
    }, this.INACTIVITY_TIMEOUT);
  }

  private handleInactivityTimeout(): void {
    // Показываем уведомление пользователю
    const message =
      "Время сессии истекло. Пожалуйста, начните авторизацию заново.";

    if (this.$PLATFORM !== "web") {
      Toast.show({
        text: message,
        duration: "short",
      });
    } else {
      toast(message, {
        type: "warning",
        autoClose: 3000,
      });
    }

    // Сбрасываем данные и возвращаемся на начальный шаг
    this.resetDataAndGoToStart();

    Sentry.withScope((scope) => {
      scope.setLevel("info");
      scope.setTag("login_timeout", "inactivity");
      scope.setContext("last_step", {
        step: this.currentStep,
        phone: this.phone ? "present" : "absent",
      });
      Sentry.captureMessage("User login session expired due to inactivity");
    });
  }

  private clearInactivityTimer(): void {
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = null;
    }
  }

  private telegramSupportLoading = false;
  private loginType: "phone" | "telegram" = "phone";

  private async handleTelegramSupportRequest() {
    const steps: Record<ELoginStep, string> = {
      [ELoginStep.EnterPhone]: "Этап: ввод номера телефона",
      [ELoginStep.CreatePass]: "Этап: установка пароля",
      [ELoginStep.RepeatPass]: "Этап: повтор пароля",
      [ELoginStep.CheckOTP]: "Этап: ввод кода",
      [ELoginStep.EnterEmail]: "Этап: ввод email",
      [ELoginStep.CheckEmail]: "Этап: подтверждение email",
      [ELoginStep.TelegramRedirect]: "Этап: редирект в Telegram",
      [ELoginStep.ActivationMethod]: "Этап: выбор метода активации",
      [ELoginStep.Confirmation]: "Этап: подтверждение звонка",
    };

    let message = `Проблема при входе в приложение.\n`;
    message += `Тип приложения: ${this.$APP_TYPE}\n`;
    message += `Платформа: ${this.$PLATFORM}\n`;
    message += steps[this.currentStep] || "Неизвестный этап";
    if (this.phone) message += `\nНомер: ${this.phone}`;
    if (this.appVersion)
      message += `\nВерсия: ${this.appVersion} (${this.appBuild})`;
    if (store.state.appName && this.isBrand.length)
      message += `\nБренд: ${store.state.appName}`;

    this.helpLoginDialog = false;

    const baseRedirectUrl = process.env.VUE_APP_TELEGRAM_SUPPORT_BOT_URL;
    let finalUrl = baseRedirectUrl;

    try {
      const response = await fetch("https://brand.force2.cc/api/messages", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ message }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.code) {
          finalUrl = `${baseRedirectUrl}?start=${encodeURIComponent(
            `tmp=${data.code}`,
          )}`;
        }
      }
    } catch (e) {
      console.warn("Support fetch failed, using base URL:", e);
    }
    await this.openUrlInNewTab(finalUrl);
  }

  private async openUrlInNewTab(url: string): Promise<void> {
    if (this.$PLATFORM !== "web" && typeof Browser !== "undefined") {
      try {
        await Browser.open({
          url: url,
          windowName: "_blank",
        });
        return;
      } catch (error) {
        console.warn("Browser.open failed, falling back:", error);
      }
    }

    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.style.display = "none";
    link.setAttribute("aria-hidden", "true");

    document.body.appendChild(link);

    try {
      link.click();
    } catch (e) {
      window.open(url, "_blank", "noopener,noreferrer");
    }

    setTimeout(() => {
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
    }, 100);
  }

  private async handleMAXSupportRequest() {
    this.helpLoginDialog = false;
    window.open(process.env.VUE_APP_MAX_SUPPORT_BOT_URL, "_blank");
  }

  private pendingCallMessages = [
    "Вы точно позвонили? Попробуйте ещё раз.",
    "Звонок не прошёл. Позвоните ещё раз.",
    "Мы не зафиксировали ваш звонок. Попробуйте снова.",
    "Убедитесь, что звонок производился на указанный номер.",
    "Проверьте, правильно ли ввели номер.",
  ];

  private activeTab: "call" | "code" = "call";
  private remainingTime = 300;
  private pollingActive = false;
  private isCallConfirmed = false;
  private timerId: number | null = null;
  private showCloseConfirm = false;
  private manualCode = "";
  private isSubmittingCode = false;
  private isActivationFlow = false;
  private isManualCallCheckDisabled = false;
  private initialPollTimeout: number | null = null;
  private slowPollInterval: number | null = null;

  private backBtn() {
    this.switchTab("call");
    this.manualCode = "";
  }

  private async copyNumber(phone: string) {
    let copySuccess = false;
    const textToCopy = "+" + phone.replace(/\D/g, "");

    if (this.$PLATFORM !== "web") {
      try {
        await Clipboard.write({
          string: textToCopy,
        });
        copySuccess = true;
      } catch (error) {
        console.error("Capacitor Clipboard write failed:", error);
      }
    }

    if (!copySuccess) {
      try {
        if (
          navigator.clipboard &&
          typeof navigator.clipboard.writeText === "function"
        ) {
          await navigator.clipboard.writeText(textToCopy);
          copySuccess = true;
        } else {
          console.warn("navigator.clipboard API not available");
        }
      } catch (error) {
        console.error("navigator.clipboard write failed:", error);
      }
    }

    if (copySuccess) {
      if (this.$PLATFORM !== "web") {
        await Toast.show({
          text: "Номер скопирован",
          duration: "short",
        });
      } else {
        toast("Номер скопирован", {
          type: "success",
          autoClose: 2000,
        });
      }
    } else {
      if (this.$PLATFORM !== "web") {
        await Toast.show({
          text: "Не удалось скопировать номер",
          duration: "short",
        });
      } else {
        toast("Не удалось скопировать номер", {
          type: "error",
          autoClose: 3000,
        });
      }
      console.error("Failed to copy phone number using both methods.");
    }
  }

  private startCountdown() {
    if (this.timerId) clearInterval(this.timerId);
    this.timerId = window.setInterval(() => {
      if (this.remainingTime > 0) {
        this.remainingTime--;
      }
    }, 1000);
  }

  private startPolling() {
    this.pollingActive = true;
    const initialTimeout = setTimeout(async () => {
      await this.checkStatus();
      let secondsElapsed = 5;
      const fastPollInterval = setInterval(async () => {
        if (!this.pollingActive || this.isCallConfirmed) {
          clearInterval(fastPollInterval);
          return;
        }
        secondsElapsed += 3;
        await this.checkStatus();
        if (secondsElapsed >= 65) {
          clearInterval(fastPollInterval);
          this.startSlowPolling();
        }
      }, 3000);
      this.slowPollInterval = fastPollInterval;
    }, 5000);
    this.initialPollTimeout = initialTimeout as unknown as number;
  }

  private startSlowPolling() {
    if (!this.pollingActive || this.isCallConfirmed) return;
    const slowPollInterval = setInterval(async () => {
      if (!this.pollingActive || this.isCallConfirmed) {
        clearInterval(slowPollInterval);
        return;
      }
      await this.checkStatus();
    }, 60000);
    this.slowPollInterval = slowPollInterval;
  }

  private stopPolling() {
    this.pollingActive = false;
    if (this.slowPollInterval) {
      clearInterval(this.slowPollInterval);
      this.slowPollInterval = null;
    }
  }

  private async checkStatus() {
    if (!this.confirmationId) return;
    try {
      const response = await ApiEnter.checkCallStatus(this.confirmationId);

      if (response?.status === "verified") {
        this.isCallConfirmed = true;
        this.stopPolling();

        if (this.isActivationFlow) {
          await this.loginApp();
        } else {
          await this.finalizeLoginAfterVerification();
        }
        return;
      }

      if (
        response?.status === "failed" &&
        response?.detail === "CONFIRMED_CALL_ERROR"
      ) {
        this.stopPolling();
        if (this.$PLATFORM !== "web") {
          await Toast.show({
            text: "Время на звонок истекло. Попробуйте сначала.",
            duration: "short",
          });
        } else {
          toast("Время на звонок истекло. Попробуйте сначала.", {
            type: "error",
            autoClose: 4000,
          });
        }
        this.resetDataAndGoToStart();
        return;
      }
    } catch (error) {
      this.stopPolling();
      if (this.$PLATFORM !== "web") {
        await Toast.show({
          text: "Не удалось проверить статус звонка.",
          duration: "short",
        });
      } else {
        toast("Не удалось проверить статус звонка.", {
          type: "error",
          autoClose: 4000,
        });
      }
      Sentry.captureException(error, {
        tags: { login_step: "confirmation_poll" },
      });
    }
  }

  private async finalizeLoginAfterVerification() {
    if (this.hasRequest || !this.confirmationId) return;

    this.hasRequest = true;
    try {
      const response = await ApiEnter.finalizeConfirmation(this.confirmationId);

      if (isAuthSuccess(response)) {
        await UtilStorage.setItem("token", response.access_token);
        await UtilStorage.setItem("token_type", response.token_type as string);
        Sentry.setUser({ username: this.phone });
        await this.savePhoneToStorage();
        await this.redirectToHome();
        this.getUserData?.();
        this.resetData();
      } else {
        const detail = response?.detail;
        switch (detail) {
          case "CONFIRMATION_REQUIRED":
            if (this.$PLATFORM !== "web") {
              await Toast.show({
                text: "Подтверждение еще не завершено или уже сброшено.",
                duration: "short",
              });
            } else {
              toast("Подтверждение еще не завершено или уже сброшено.", {
                type: "error",
                autoClose: 4000,
              });
            }
            break;
          case "INVALID_CONFIRMATION_CODE":
            if (this.$PLATFORM !== "web") {
              await Toast.show({
                text: "Неверный идентификатор подтверждения.",
                duration: "short",
              });
            } else {
              toast("Неверный идентификатор подтверждения.", {
                type: "error",
                autoClose: 4000,
              });
            }
            break;
          case "CONFIRMATION_VERIFIED":
            if (this.$PLATFORM !== "web") {
              await Toast.show({
                text: "Подтверждение уже было завершено ранее.",
                duration: "short",
              });
            } else {
              toast("Подтверждение уже было завершено ранее.", {
                type: "error",
                autoClose: 4000,
              });
            }
            break;
          case "INVALID_DEVICE_HASH":
            if (this.$PLATFORM !== "web") {
              await Toast.show({
                text: "Запрос отправлен с другого устройства. Повторите вход.",
                duration: "short",
              });
            } else {
              toast("Запрос отправлен с другого устройства. Повторите вход.", {
                type: "error",
                autoClose: 4000,
              });
            }
            break;
          case "CONFIRMED_CALL_ERROR":
            if (this.$PLATFORM !== "web") {
              await Toast.show({
                text: "Данные подтверждения повреждены или устарели.",
                duration: "short",
              });
            } else {
              toast("Данные подтверждения повреждены или устарели.", {
                type: "error",
                autoClose: 4000,
              });
            }
            break;
          default:
            UtilError.validateErrorMessage(
              detail || "UNKNOWN_ERROR",
              this.phone,
              UtilError.backendMessageOf(response),
              UtilError.backendRequestIdOf(response),
            );
        }
        this.resetData();
      }
    } catch (error) {
      if (this.$PLATFORM !== "web") {
        await Toast.show({
          text: "Ошибка при завершении входа.",
          duration: "short",
        });
      } else {
        toast("Ошибка при завершении входа.", {
          type: "warning",
          autoClose: 4000,
        });
      }
      Sentry.captureException(error, {
        tags: { login_step: "finalize_login" },
      });
      this.resetData();
    } finally {
      this.hasRequest = false;
    }
  }

  private resetDataAndGoToStart() {
    this.clearInactivityTimer();
    this.cleanup();
    this.manualCode = "";
    this.confirmationId = null;
    this.phoneNumberCallConfirmed = [];
    this.isCallConfirmed = false;
    this.activeTab = "call";

    this.phone = "";
    this.password = "";
    this.passwordRepeat = "";
    this.otp = "";
    this.isNeedRegistration = false;
    this.hasRequest = false;
    this.termsConditionFirst = false;
    this.termsConditionSecond = false;
    this.isActivationFlow = false;

    UtilStorage.removeItem("loginPhone");
    UtilStorage.removeItem("loginPassword");
    UtilStorage.removeItem("loginStep");
    UtilStorage.removeItem("loginNeedRegistration");
    UtilStorage.removeItem("activationPassword");

    this.currentStep = ELoginStep.EnterPhone;
  }

  private async manuallyCheckStatus() {
    if (!this.confirmationId) return;
    this.isManualCallCheckDisabled = true;

    try {
      const response = await ApiEnter.checkCallStatus(this.confirmationId);

      if (response?.status === "verified") {
        this.isCallConfirmed = true;
        this.stopPolling();
        if (this.isActivationFlow) {
          await this.loginApp();
        } else {
          await this.finalizeLoginAfterVerification();
        }
        return;
      }

      if (response?.status === "pending") {
        const randomMessage =
          this.pendingCallMessages[
            Math.floor(Math.random() * this.pendingCallMessages.length)
          ];

        if (this.$PLATFORM !== "web") {
          await Toast.show({
            text: randomMessage,
            duration: "short",
          });
        } else {
          toast(randomMessage, {
            type: "warning",
            autoClose: 4000,
          });
        }
        return;
      }

      if (response?.detail === "CONFIRMED_CALL_ERROR") {
        this.stopPolling();
        if (this.$PLATFORM !== "web") {
          await Toast.show({
            text: "Время на звонок истекло. Попробуйте сначала.",
            duration: "short",
          });
        } else {
          toast("Время на звонок истекло. Попробуйте сначала.", {
            type: "error",
            autoClose: 3000,
          });
        }
        this.resetDataAndGoToStart();
        return;
      }
    } catch (error) {
      this.stopPolling();
      if (this.$PLATFORM !== "web") {
        await Toast.show({
          text: "Не удалось проверить статус звонка",
          duration: "short",
        });
      } else {
        toast("Не удалось проверить статус звонка", {
          type: "error",
          autoClose: 3000,
        });
      }
      Sentry.captureException(error, {
        tags: { login_step: "confirmation_manual_check" },
      });
    } finally {
      setTimeout(() => {
        this.isManualCallCheckDisabled = false;
      }, 5000);
    }
  }

  private switchTab(tab: "call" | "code") {
    if (tab === "code") {
      this.stopPolling();
    } else {
      if (!this.pollingActive && !this.isCallConfirmed) {
        this.startPolling();
      }
    }
    this.activeTab = tab;
  }

  private validateManualCode() {
    this.manualCode = this.manualCode.replace(/\D/g, "").substring(0, 5);
  }

  private async submitManualCode() {
    if (this.manualCode.length !== 5 || !this.confirmationId) return;
    this.isSubmittingCode = true;

    try {
      const response = await ApiEnter.confirmByCode(
        this.confirmationId,
        this.manualCode,
      );

      if (response?.detail === "ACCOUNT_ACTIVATED" || isAuthSuccess(response)) {
        await this.loginApp();
      } else if (response?.detail === "INVALID_CONFIRMATION_CODE") {
        if (this.$PLATFORM !== "web") {
          await Toast.show({
            text: "Неверный код подтверждения",
            duration: "short",
          });
        } else {
          toast("Неверный код подтверждения", {
            type: "error",
            autoClose: 3000,
          });
        }
        this.manualCode = "";
      } else {
        UtilError.validateErrorMessage(
          response?.detail || "UNKNOWN_ERROR",
          this.phone,
          response?.message,
          response?.request_id,
        );
      }
    } catch (error) {
      if (this.$PLATFORM !== "web") {
        await Toast.show({
          text: "Ошибка отправки кода",
          duration: "short",
        });
      } else {
        toast("Ошибка отправки кода", {
          type: "error",
          autoClose: 3000,
        });
      }
      Sentry.captureException(error, {
        tags: { login_step: "confirmation_manual_code" },
      });
    } finally {
      this.isSubmittingCode = false;
    }
  }

  private async handleCloseConfirmation() {
    this.cleanup();
    this.resetData();
    await this.$router.replace("/");
  }

  private cleanup() {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
    if (this.initialPollTimeout) {
      clearTimeout(this.initialPollTimeout);
      this.initialPollTimeout = null;
    }
    if (this.slowPollInterval) {
      clearInterval(this.slowPollInterval);
      this.slowPollInterval = null;
    }
    this.clearInactivityTimer();
    this.pollingActive = false;
    this.remainingTime = 300;
    this.isActivationFlow = false;
    this.isCallConfirmed = false;
  }

  private blockUnload(e: BeforeUnloadEvent) {
    e.preventDefault();
    e.returnValue = "";
  }

  private formatPhoneNumber(phone: string): string {
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.length === 11 && cleaned.startsWith("8")) {
      return `+7 ${cleaned.substring(1, 4)} ${cleaned.substring(
        4,
        7,
      )} ${cleaned.substring(7, 9)} ${cleaned.substring(9, 11)}`;
    } else if (cleaned.length === 10) {
      return `+7 ${cleaned.substring(0, 3)} ${cleaned.substring(
        3,
        6,
      )} ${cleaned.substring(6, 8)} ${cleaned.substring(8, 10)}`;
    }
    return phone;
  }

  private formatTime(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  }

  private formatCallConfirmNumber(phone: string): string {
    const cleaned = phone.replace(/\D/g, "");
    let digits = cleaned;
    if (digits.length === 11 && digits.startsWith("8")) {
      digits = "7" + digits.substring(1);
    }
    if (digits.length === 11 && digits.startsWith("7")) {
      return `+7(${digits.substring(1, 4)})${digits.substring(4, 7)}-${digits.substring(7, 9)}-${digits.substring(9, 11)}`;
    }
    if (digits.length === 10) {
      return `+7(${digits.substring(0, 3)})${digits.substring(3, 6)}-${digits.substring(6, 8)}-${digits.substring(8, 10)}`;
    }
    return phone;
  }

  private handleHelpButtonClick(): void {
    if (!this.isHelpButtonEnabled) {
      const message = "Введите номер телефона";
      if (this.$PLATFORM !== "web") {
        void Toast.show({ text: message }).catch((error) => {
          if (error.code !== "in_progress") {
            console.error("Toast error:", error);
          }
        });
      } else {
        toast(message, {
          autoClose: 3000,
          type: "warning",
        });
      }
      return;
    }
    this.helpLoginDialog = true;
  }

  @Watch("password")
  watchPasswordInput(value: string) {
    const MAX_PASSWORD_LENGTH = 5;

    if (value.length > MAX_PASSWORD_LENGTH) {
      this.password = value.substring(0, MAX_PASSWORD_LENGTH);
    }
  }

  @Watch("passwordRepeat")
  watchPasswordRepeat(value: string): void {
    const MAX_PASSWORD_LENGTH = 5;

    if (value.length === MAX_PASSWORD_LENGTH && value !== this.password) {
      this.passwordRepeatError = "Пароли не совпадают, попробуйте еще раз";
      this.passwordRepeat = "";
    }
  }

  get currentStep(): ELoginStep {
    return this.getCurrentStep as ELoginStep;
  }

  set currentStep(value: ELoginStep) {
    if (this.setCurrentStep) {
      this.setCurrentStep(value);
    }
  }

  get phone(): string {
    return this.getLoginPhone as string;
  }

  set phone(value: string) {
    if (this.setLoginPhone) {
      this.setLoginPhone(value);
    }
  }

  get password(): string {
    return this.getLoginPassword as string;
  }

  set password(value: string) {
    if (this.setLoginPassword) {
      this.setLoginPassword(value);
    }
  }

  get isNeedRegistration(): boolean {
    return this.getIsNeedRegistration as boolean;
  }

  set isNeedRegistration(value: boolean) {
    if (this.setIsNeedRegistration) {
      this.setIsNeedRegistration(value);
    }
  }

  private passwordRepeat = "";
  private otp = "";
  private enumLoginSteps = ELoginStep;
  private passwordRepeatError = "";
  private passwordError = "";
  private otpError = "";
  private hasRequest = false;
  private termsConditionFirst = false;
  private termsConditionSecond = false;
  private confirmationId: string | null = null;
  private phoneNumberCallConfirmed: string[] = [];
  private appVersion: null | string = null;
  private appBuild: null | string = null;

  private helpLoginDialog = false;

  public async sendPhoneToValidate(): Promise<void> {
    this.isNeedRegistration = false;
    this.hasRequest = true;

    const phone = "+7" + this.phone.replace(/\D/g, "");

    const response = await ApiEnter.validateEnter(phone);
    const responseDetail = response?.detail?.toLowerCase() || "";
    console.log("Extracted detail:", response);

    if (
      responseDetail === "user_not_activation" ||
      responseDetail === "USER_NOT_ACTIVATION"
    ) {
      this.isNeedRegistration = true;
      this.currentStep = ELoginStep.TelegramRedirect;
    } else if (
      responseDetail === "user_activate" ||
      responseDetail === "USER_ACTIVATE"
    ) {
      this.currentStep = ELoginStep.CreatePass;
    } else {
      UtilError.validateErrorMessage(
        responseDetail,
        phone,
        response?.message,
        response?.request_id,
      );
      Sentry.withScope((scope) => {
        scope.setLevel("warning");
        scope.setTag("Login", "validate_phone");
        scope.setUser({ username: phone });
        scope.setContext("response", responseDetail);
        Sentry.captureMessage("Unexpected response from validateEnter");
      });
    }

    if (
      responseDetail === "user_not_activation" ||
      responseDetail === "USER_NOT_ACTIVATION" ||
      responseDetail === "user_activate" ||
      responseDetail === "USER_ACTIVATE"
    ) {
      this.phone = phone;
    }

    this.hasRequest = false;
  }

  private async validateIsNeedRegistration(): Promise<void> {
    if (this.isNeedRegistration) {
      if (!this.isCreateContinueEnabled) {
        return;
      }
      this.currentStep = ELoginStep.RepeatPass;
      return;
    }

    await this.loginApp();
  }

  private async sendNewCall() {
    if (this.callsTries >= 2) return;

    this.hasRequest = true;
    let response;

    try {
      if (this.isNeedRegistration) {
        response = await ApiEnter.activateUser(this.phone, this.password);
      } else {
        response = await ApiEnter.loginUser(this.phone, this.password);
      }

      if (response?.confirmation_id) {
        this.cleanup();
        this.manualCode = "";
        this.confirmationId = response.confirmation_id;
        this.phoneNumberCallConfirmed = this.extractPhoneNumbers(
          response.phone_number_call_confirmed,
        );
        this.currentStep = ELoginStep.Confirmation;
        return;
      }

      if (
        response?.detail === "USER_NOT_VERIFICATION" ||
        response?.detail === "CONFIRMATION_REQUIRED"
      ) {
        this.callsTries += 1;
        this.startOTPInterval();
        return;
      }

      if (response?.detail) {
        UtilError.validateErrorMessage(
          response.detail,
          this.phone,
          UtilError.backendMessageOf(response),
          UtilError.backendRequestIdOf(response),
        );
      }
    } finally {
      this.hasRequest = false;
    }
  }
  private extractPhoneNumbers(raw: unknown): string[] {
    if (Array.isArray(raw)) {
      return raw.filter(
        (n): n is string => typeof n === "string" && n.trim() !== "",
      );
    }
    if (typeof raw === "string" && raw.trim() !== "") {
      return [raw];
    }
    return [];
  }

  private async loginApp() {
    if (this.hasRequest) {
      return;
    }

    this.hasRequest = true;

    const response = await ApiEnter.loginUser(this.phone, this.password);

    this.hasRequest = false;

    // if (response?.confirmation_id) {
    //   this.cleanup();
    //   this.manualCode = "";
    //   this.confirmationId = response.confirmation_id;
    //   this.phoneNumberCallConfirmed = this.extractPhoneNumbers(
    //     response.phone_number_call_confirmed,
    //   );
    //   this.isActivationFlow = false;
    //   this.currentStep = ELoginStep.Confirmation;
    //   return;
    // }

    if (isAuthSuccess(response)) {
      await UtilStorage.setItem("token", response.access_token);
      await UtilStorage.setItem("token_type", response.token_type as string);

      // const visitorId = await UtilStorage.getItem("visitor_id");

      // if (!visitorId) {
      //   await UtilStorage.setItem(
      //     "visitor_id",
      //     "66102dd837dd470f82bf511e2fe097c9",
      //   );
      // }
      Sentry.setUser({ username: this.phone });
      await this.savePhoneToStorage();
      await this.redirectToHome();
      this.getUserData?.();
      this.resetData();
      return;
    }

    // if (response?.confirmation_id) {
    //   this.confirmationId = response.confirmation_id;
    //   const rawNumbers = response.phone_number_call_confirmed;
    //   this.phoneNumberCallConfirmed = Array.isArray(rawNumbers)
    //     ? rawNumbers.filter(
    //         (n): n is string => typeof n === "string" && n.trim() !== "",
    //       )
    //     : [rawNumbers].filter(
    //         (n): n is string => typeof n === "string" && n.trim() !== "",
    //       );
    //   this.isActivationFlow = false;
    //   this.currentStep = ELoginStep.Confirmation;
    //   return;
    // }

    if (response?.detail === "USER_NOT_VERIFICATION") {
      const otpStatus = (response.otp_status || "").toLowerCase();
      if (otpStatus === "tm_send") {
        // Код отправлен в Telegram → вводим код
        this.loginType = "telegram";
        this.currentStep = ELoginStep.CheckOTP;
        this.startOTPInterval();
      } else {
        // Звонок ожидается → подтверждение звонка
        this.loginType = "phone";
        this.confirmationId = response.confirmation_id ?? null;
        this.phoneNumberCallConfirmed = this.extractPhoneNumbers(
          response.phone_number_call_confirmed,
        );
        this.isActivationFlow = false;
        this.currentStep = ELoginStep.Confirmation;
      }
      return;
    }

    if (response?.detail) {
      UtilError.validateErrorMessage(
        response.detail,
        this.phone,
        UtilError.backendMessageOf(response),
        UtilError.backendRequestIdOf(response),
      );
      await Sentry.setUser({ username: this.phone });
      // Sentry.captureMessage("Error with loginUserWithPhone", {
      //   extra: {
      //     responseBack: JSON.stringify(response),
      //     requestData: `phone: ${this.phone}`,
      //   },
      // });
      Sentry.withScope((scope) => {
        scope.setLevel("error");
        scope.setContext("request", { phone: this.phone });
        scope.setContext("response", {
          error: response?.error,
          detail: response?.detail,
          otp_status: response?.otp_status,
          error_description: response?.error_description,
          username: response?.username,
        });
        scope.setUser({ username: this.phone });
        scope.setTag("Login", "login_user");
        Sentry.captureMessage("Error with loginUserWithPhone");
      });
      this.resetData();
    }
  }

  private async handleAuthSuccess(response: any) {
    if (isAuthSuccess(response)) {
      await UtilStorage.setItem("token", response.access_token);
      await UtilStorage.setItem("token_type", response.token_type as string);
      Sentry.setUser({ username: this.phone });
      await this.savePhoneToStorage();
      await this.redirectToHome();
      this.getUserData?.();
      this.resetData();
      return;
    }

    if (response?.detail === "ACCOUNT_ACTIVATED") {
      await this.loginApp();
      return;
    }

    UtilError.validateErrorMessage(
      response?.detail || "UNKNOWN_ERROR",
      this.phone,
      response?.message,
      response?.request_id,
    );
    this.resetData();
  }

  private startOTPInterval(otp_interval?: number) {
    this.nextCallTime = otp_interval || 100;
    const otpInterval = setInterval(() => {
      this.nextCallTime -= 1;

      if (this.nextCallTime <= 0) {
        clearInterval(otpInterval);
      }
    }, 1000);
  }

  private async savePhoneToStorage() {
    await UtilStorage.setItem("phone", this.phone.replace(/\D/g, ""));
  }

  private async redirectToHome() {
    await this.$router.replace("/home");
  }

  private processPhoneInput(input: string): string {
    let cleaned = input.replace(/\D/g, "");
    if (cleaned.startsWith("7") || cleaned.startsWith("8")) {
      cleaned = cleaned.substring(1);
    }
    return cleaned.substring(0, 10);
  }

  private validateFieldInput(field: "otp" | "phone"): void {
    if (field === "phone") {
      this.phone = this.processPhoneInput(this.phone);
      UtilStorage.setItem("phoneRegisterYandex", this.phone);
    }

    this[field] = this[field].replace(/[^\d, ^s()]/g, "");
  }

  private onFocusPassword(field: "password" | "passwordRepeat") {
    const input = this.$refs.input as unknown as HTMLInputElement[];
    const currentField = input[this[field].length];
    if (currentField) currentField.select();
  }

  private onPaste(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData("text/plain") || "";
    this.phone = this.processPhoneInput(pastedData);
    UtilStorage.setItem("phoneRegisterYandex", this.phone);
  }

  private inputPasswordEvent(
    field: "password" | "passwordRepeat",
    value: string,
  ): void {
    const cleanedValue = value.replace(/\D/g, "");
    this[field] += cleanedValue;
    if (this[field].length < 5) {
      const input = this.$refs.input as unknown as HTMLInputElement[];
      input[this[field].length].select();
    }
  }

  private keyDownEvent(field: "password" | "passwordRepeat") {
    this[field] = this[field].substring(0, this[field].length - 1);
    const input = this.$refs.input as unknown as HTMLInputElement[];
    const currentInput = input[this[field].length];
    if (currentInput) {
      currentInput.select();
    }
  }

  private async validateOTP(): Promise<void> {
    if (this.otp.length !== 5) {
      return;
    }

    if (!this.statusConnection) {
      this.otpError =
        this.loginType == "phone"
          ? "Положите трубку и введите код из звонка!"
          : "Восстановите подключение к интернету и введите код из Telegram!";
      this.otp = "";
      return;
    }

    this.hasRequest = true;
    this.otpError = "";

    let response;

    if (this.isNeedRegistration) {
      response = await ApiEnter.sendCodeActivation(this.otp);
    } else {
      response = await ApiEnter.sendCode(this.otp);
    }

    this.hasRequest = false;

    if (isAuthSuccess(response)) {
      await UtilStorage.setItem("token", response.access_token);
      await UtilStorage.setItem("token_type", response.token_type as string);
      Sentry.setUser({ username: this.phone });
      await this.savePhoneToStorage();
      await this.redirectToHome();
      this.getUserData?.();
      this.resetData();
      return;
    }

    if (
      typeof response != "boolean" &&
      response.detail === "ACCOUNT_ACTIVATED"
    ) {
      await this.loginApp();
      return;
    }

    switch (response?.detail) {
      case "INVALID_CONFIRMATION_CODE":
        this.otpError = "Введен неправильный код, попробуйте еще раз";
        this.otp = "";
        break;

      case "INVALID_CODE":
        this.otpError = "Введен неправильный код, попробуйте еще раз";
        this.otp = "";
        break;

      case "LIMITING_INPUT_ATTEMPTS":
        this.resetData();
        UtilError.validateErrorMessage("LIMITING_INPUT_ATTEMPTS", this.phone);
        Sentry.withScope((scope) => {
          scope.setLevel("info");
          scope.setTag("Login", "verify_otp");
          scope.setUser({ username: this.phone });
          Sentry.captureMessage("User hit OTP attempt limit");
        });
        break;

      default:
        UtilError.validateErrorMessage(
          response.detail,
          this.phone,
          response?.message,
          response?.request_id,
        );
        // Sentry.captureMessage("Error with sendOtp", {
        //   extra: {
        //     responseBack: JSON.stringify(response),
        //     requestData: JSON.stringify(this.otp),
        //   },
        // });
        Sentry.withScope((scope) => {
          scope.setLevel("error");
          scope.setContext("request", { otp_length: this.otp.length });
          scope.setUser({ username: this.phone });
          scope.setTag("Login", "verify_otp");
          Sentry.captureMessage("Error with sendOtp");
        });
        break;
    }
  }

  private async activateUser(): Promise<void> {
    this.currentStep = ELoginStep.ActivationMethod;
  }

  private async sendActivationCall() {
    this.hasRequest = true;
    const response = await ApiEnter.activateUser(this.phone, this.password);
    this.hasRequest = false;

    // if (response?.confirmation_id) {
    //   this.cleanup();
    //   this.manualCode = "";
    //   this.confirmationId = response.confirmation_id;
    //   this.phoneNumberCallConfirmed = this.extractPhoneNumbers(
    //     response.phone_number_call_confirmed,
    //   );
    //   this.isActivationFlow = true;
    //   this.currentStep = ELoginStep.Confirmation;
    //   return;
    // }

    // if (response?.confirmation_id) {
    //   this.confirmationId = response.confirmation_id;
    //   const rawNumbers = response.phone_number_call_confirmed;
    //   this.phoneNumberCallConfirmed = Array.isArray(rawNumbers)
    //     ? rawNumbers.filter(
    //         (n): n is string => typeof n === "string" && n.trim() !== "",
    //       )
    //     : [rawNumbers].filter(
    //         (n): n is string => typeof n === "string" && n.trim() !== "",
    //       );
    //   this.isActivationFlow = true;
    //   this.currentStep = ELoginStep.Confirmation;
    //   return;
    // }

    if (response?.detail === "CONFIRMATION_REQUIRED") {
      const otpStatus = (response.otp_status || "").toLowerCase();
      if (otpStatus === "tm_send") {
        this.loginType = "telegram";
        this.currentStep = ELoginStep.CheckOTP;
        this.startOTPInterval();
      } else {
        this.loginType = "phone";
        this.confirmationId = response.confirmation_id;
        this.phoneNumberCallConfirmed = this.extractPhoneNumbers(
          response.phone_number_call_confirmed,
        );
        this.isActivationFlow = true;
        this.currentStep = ELoginStep.Confirmation;
      }
      return;
    }

    if (response?.detail) {
      UtilError.validateErrorMessage(
        response.detail,
        this.phone,
        UtilError.backendMessageOf(response),
        UtilError.backendRequestIdOf(response),
      );
    }
  }

  private async checkIsSuccessLogin() {
    const phone = await UtilStorage.getItem("phone");

    if (phone) {
      this.phone = "+" + phone;
      this.currentStep = ELoginStep.CreatePass;
    }
  }

  private resetData() {
    this.clearYandexButton();
    this.clearInactivityTimer();
    // this.phone = "";
    this.password = "";
    this.passwordRepeat = "";
    this.otp = "";
    this.termsConditionFirst = false;
    this.termsConditionSecond = false;
    this.isNeedRegistration = false;
    this.hasRequest = false;
    this.currentStep = ELoginStep.EnterPhone;
    this.isActivationFlow = false;
    this.showCloseConfirm = false;
    UtilStorage.removeItem("loginPhone");
    UtilStorage.removeItem("loginPassword");
    UtilStorage.removeItem("loginStep");
    UtilStorage.removeItem("loginNeedRegistration");
    UtilStorage.removeItem("activationPassword");
  }

  private async openLink(link: string) {
    await Browser.open({ url: link });
  }

  private changePhone() {
    this.resetData();
    this.manualCode = "";
    UtilStorage.removeItem("phone");
  }

  private openTelegram() {
    window.open(process.env.VUE_APP_TELEGRAM_URL, "_blank");
    this.resetData();
  }

  private onTelegramCodeLinkClick() {
    this.openUrlInNewTab(process.env.VUE_APP_TELEGRAM_URL);
  }

  private callsTries = 0;
  private nextCallTime = 0;

  async activated() {
    this.resetData();

    if (this.$PLATFORM === "ios") {
      const wrapper = document.getElementById("login");
      if (wrapper) {
        wrapper.style.minHeight = "-webkit-fill-available";
        wrapper.style.position = "relative";
      }
    }

    try {
      const loginStep = await UtilStorage.getItem("loginStep");
      const loginPhone = await UtilStorage.getItem("loginPhone");
      const loginPassword = await UtilStorage.getItem("loginPassword");
      const loginNeedRegistration = await UtilStorage.getItem(
        "loginNeedRegistration",
      );

      // ПРАВИЛЬНО: сравниваем сохраненный шаг с enum
      if (
        loginStep &&
        Number(loginStep) === ELoginStep.CheckOTP &&
        loginPhone &&
        loginPassword
      ) {
        this.phone = loginPhone;
        this.password = loginPassword;
        this.currentStep = ELoginStep.CheckOTP;
        if (loginNeedRegistration === "true") {
          this.isNeedRegistration = true;
        }
        if (this.nextCallTime === 0) {
          // Или 100, как у вас было
          this.startOTPInterval();
        }
      }
    } catch (e) {
      Sentry.withScope((scope) => {
        scope.setTag("Login", "session_restore");
        Sentry.captureException(e);
      });
    }
  }

  private yandexButtonInitialized = false;

  updated() {
    if (
      this.currentStep === ELoginStep.CreatePass &&
      !this.isNeedRegistration &&
      this.yandexAppEnabled
    ) {
      const container = document.getElementById("yandex-auth-container-login");
      if (
        container &&
        !this.yandexButtonInitialized &&
        container.children.length === 0
      ) {
        this.initYandexButton(container);
      }
    }

    if (
      this.currentStep === this.enumLoginSteps.ActivationMethod &&
      this.isNeedRegistration &&
      this.yandexAppEnabled
    ) {
      const container = document.getElementById(
        "yandex-auth-container-activation",
      );
      if (
        container &&
        !this.yandexButtonInitialized &&
        container.children.length === 0
      ) {
        this.$nextTick(() => {
          this.initYandexButton(container);
        });
      }
    }
  }

  @Watch("yandexAppEnabled")
  onYandexAppEnabledChanged() {
    this.$nextTick(() => {
      if (
        this.currentStep === ELoginStep.CreatePass &&
        !this.isNeedRegistration &&
        this.yandexAppEnabled
      ) {
        const container = document.getElementById(
          "yandex-auth-container-login",
        );
        if (container) {
          this.yandexButtonInitialized = false;
          this.initYandexButton(container);
        }
      }
    });
  }

  private clearYandexButton() {
    const loginContainer = document.getElementById(
      "yandex-auth-container-login",
    );
    const activationContainer = document.getElementById(
      "yandex-auth-container-activation",
    );

    if (loginContainer) loginContainer.innerHTML = "";
    if (activationContainer) activationContainer.innerHTML = "";

    this.yandexButtonInitialized = false;
  }

  private async initYandexButton(container: HTMLElement) {
    if (this.yandexButtonInitialized || container.children.length > 0) {
      return;
    }
    await UtilStorage.setItem("phoneRegisterYandex", this.phone);

    const clientId = this.yandexClientId || "";
    // const clientId = "ca1d664ca450408da516c63004184100";
    const redirectUri =
      this.$PLATFORM === "web"
        ? window.location.origin + "/#/login-yandex"
        : "forcemoneypro://login-yandex";

    if (this.$PLATFORM !== "web") {
      await UtilStorage.setItem("yandex_temp_password", this.password);
      container.innerHTML = "";
      const button = document.createElement("button");
      button.className = "yandex-button-custom";
      button.innerHTML = `
    <div class="yandex-button-content">
      <img
        src="/img/yandex-short.png"
        alt="Войти через Яндекс"
        class="yandex-logo rounded-full"
      >
      <span>Войти с Яндекс ID</span>
    </div>
  `;

      button.style.cssText = `
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 56px;
      border-radius: 16px;
      background: #000000;
      border: none;
      font-family: 'Montserrat', sans-serif;
      font-weight: 500;
      font-size: 16px;
      color: #FFFFFF;
      cursor: pointer;
      transition: opacity 0.2s;
    `;

      const logo = button.querySelector(".yandex-logo");
      if (logo && logo instanceof HTMLElement) {
        logo.style.width = "24px";
        logo.style.height = "24px";
        logo.style.marginRight = "12px";
        logo.style.backgroundColor = "#FC3F1E";
        logo.style.borderRadius = "50%";
      }

      const content = button.querySelector(".yandex-button-content");
      if (content && content instanceof HTMLElement) {
        content.style.display = "flex";
        content.style.alignItems = "center";
        content.style.gap = "12px";
      }

      button.addEventListener("click", async (e) => {
        e.preventDefault();
        const authUrl = `https://oauth.yandex.ru/authorize?client_id=${clientId}&response_type=token&redirect_uri=${encodeURIComponent(
          redirectUri,
        )}`;

        try {
          await Browser.open({
            url: authUrl,
            windowName: "_blank",
          });
        } catch (error) {
          console.error("Не удалось открыть авторизацию через Яндекс");
        }
      });

      container.appendChild(button);
      this.yandexButtonInitialized = true;
      return;
    }

    if (window.YaAuthSuggest) {
      this.renderYandexButton(container, clientId, redirectUri);
      return;
    }

    await this.waitForYandexSDK(3000);

    if (!window.YaAuthSuggest) {
      this.createFallbackButton(container, clientId, redirectUri);
    } else {
      this.renderYandexButton(container, clientId, redirectUri);
    }
  }

  private async waitForYandexSDK(timeout: number): Promise<void> {
    return new Promise((resolve) => {
      const startTime = Date.now();

      const checkSDK = () => {
        if (window.YaAuthSuggest) {
          resolve();
          return;
        }

        if (Date.now() - startTime < timeout) {
          setTimeout(checkSDK, 200);
        } else {
          resolve();
        }
      };

      checkSDK();
    });
  }

  private renderYandexButton(
    container: HTMLElement,
    clientId: string,
    redirectUri: string,
  ) {
    try {
      window.YaAuthSuggest.init(
        {
          client_id: clientId,
          response_type: "token",
          redirect_uri: redirectUri,
        },
        window.location.origin,
        {
          view: "button",
          parentId: container.id,
          buttonView: "main",
          buttonTheme: "light",
          buttonSize: "xl",
          buttonBorderRadius: 16,
        },
      ).then(({ handler }) => {
        handler()
          .then(async (data: YandexAuthData) => {
            let token = null;
            token = data?.access_token;

            if (!token && data && typeof data === "object") {
              const dataAny = data as any;
              for (const key in data) {
                if (key.includes("access_token")) {
                  token = dataAny[key];
                  break;
                }
              }
            }

            if (!token && window.location.hash) {
              const hash = window.location.hash.replace("#", "?");
              const params = new URLSearchParams(hash);
              token = params.get("access_token");

              if (!token && window.location.hash.includes("&access_token=")) {
                const hashParts = window.location.hash.split("&access_token=");
                if (hashParts.length > 1) {
                  token = hashParts[1].split("&")[0];
                }
              }
            }

            if (!token) {
              throw new Error("Токен Яндекса не получен");
            }

            await this.handleYandexToken(token);
          })
          .catch((error: YandexAuthError) => {
            console.error(error);
          });
      });
    } catch (error) {
      console.error(error);
      this.createFallbackButton(container, clientId, redirectUri);
    }
  }

  private createFallbackButton(
    container: HTMLElement,
    clientId: string,
    redirectUri: string,
  ) {
    container.innerHTML = "";
    const button = document.createElement("button");
    button.className = "yandex-button-fallback";
    button.textContent = "Войти через Яндекс";
    button.style.cssText = `
    display: block;
    width: 100%;
    height: 56px;
    border-radius: 16px;
    background: #ffcc00;
    border: none;
    color: #000;
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
  `;

    button.addEventListener("click", async (e) => {
      e.preventDefault();
      const authUrl = `https://oauth.yandex.ru/authorize?client_id=${clientId}&response_type=token&redirect_uri=${encodeURIComponent(
        redirectUri,
      )}`;

      if (this.$PLATFORM === "web") {
        window.open(authUrl, "_blank");
      } else {
        try {
          await Browser.open({
            url: authUrl,
            windowName: "_system",
          });
        } catch (error) {
          console.error("Не удалось открыть авторизацию через Яндекс");
        }
      }
    });

    Sentry.withScope((scope) => {
      scope.setLevel("warning");
      scope.setTag("Login", "yandex_sdk_load");
      scope.setContext("platform", { platform: this.$PLATFORM });
      Sentry.captureMessage("Yandex SDK failed to load, using fallback");
    });

    container.appendChild(button);
  }

  @Watch("currentStep")
  onStepChange(newStep: ELoginStep, oldStep: ELoginStep) {
    // Сбрасываем флаг инициализации Яндекс кнопки только при смене на/с CreatePass
    if (
      oldStep === ELoginStep.CreatePass ||
      newStep === ELoginStep.CreatePass ||
      oldStep === ELoginStep.ActivationMethod ||
      newStep === ELoginStep.ActivationMethod
    ) {
      this.yandexButtonInitialized = false;
    }
  }

  private formatPhoneForYandex(phone: string): string {
    let cleaned = phone.replace(/\D/g, "");

    if (cleaned.startsWith("8") && cleaned.length === 11) {
      cleaned = "7" + cleaned.substring(1);
    }

    if (cleaned.length < 12) {
      cleaned = "+".repeat(12 - cleaned.length) + cleaned;
    }

    return cleaned.substring(0, 12);
  }

  private async saveAuthData(response: IAuthSuccessResponse) {
    await UtilStorage.setItem("token", response.access_token);
    await UtilStorage.setItem("token_type", response.token_type);
    // await UtilStorage.setItem("visitor_id", response.visitor_id);

    if (response.refresh_token) {
      await UtilStorage.setItem("refresh_token", response.refresh_token);
    }
  }

  private async handleYandexToken(access_token: string) {
    this.hasRequest = true;
    let phoneFromStorage = await UtilStorage.getItem("phoneRegisterYandex");
    try {
      if (!phoneFromStorage) {
        const possibleKeys = [
          "phone",
          "loginPhone",
          "phoneRegister",
          "phoneYandex",
        ];
        for (const key of possibleKeys) {
          const possiblePhone = await UtilStorage.getItem(key);
          if (possiblePhone) {
            await UtilStorage.setItem("phoneRegisterYandex", possiblePhone);
            phoneFromStorage = possiblePhone;
            break;
          }
        }

        if (!phoneFromStorage) {
          console.error(
            "Номер телефона не найден. Пожалуйста, введите номер телефона и повторите авторизацию.",
          );
          return;
        }
      }

      const formattedPhone = this.formatPhoneForYandex(phoneFromStorage);

      const response = await ApiEnter.postYandexLoginCallback(
        formattedPhone,
        access_token,
        this.password || "",
      );

      if (isAuthSuccess(response)) {
        await this.saveAuthData(response);
        await this.$router.replace({ name: "Home" });
      } else {
        // Раньше здесь были только Sentry + console.error: пользователь
        // нажимал кнопку и ничего не происходило. Показываем message бека.
        UtilError.showBackendErrorBody(response);
        Sentry.withScope((scope) => {
          scope.setLevel("error");
          scope.setTag("Login", "yandex_auth");
          scope.setUser({ username: phoneFromStorage || "unknown" });
          scope.setContext("request", {
            phone: phoneFromStorage,
            hasPassword: !!this.password,
          });
          Sentry.captureException(response);
        });
        console.error("Ошибка авторизации через Яндекс");
      }
    } catch (error) {
      Sentry.withScope((scope) => {
        scope.setLevel("error");
        scope.setTag("Login", "yandex_auth");
        scope.setUser({ username: phoneFromStorage || "unknown" });
        scope.setContext("request", {
          phone: phoneFromStorage,
          hasPassword: !!this.password,
        });
        Sentry.captureException(error);
      });
      console.error("Не удалось завершить авторизацию");
    } finally {
      this.hasRequest = false;
    }
  }

  async created() {
    this.resetData();
    this.getYandexAppEnabled?.();
    this.checkIsSuccessLogin();
    if (this.$PLATFORM != "web") {
      const appInfo = await App.getInfo();
      this.appVersion = appInfo.version;
      this.appBuild = appInfo.build;
    }
  }
  beforeUnmount() {
    this.clearInactivityTimer();
    window.removeEventListener("beforeunload", this.blockUnload);
  }
}
</script>
<style scoped>
@keyframes call {
  50% {
    opacity: 0.8;
    scale: 0.98;
  }
}
.animate-pulse {
  animation: call 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>
